// leaf-town - cutscenes: a tiny director plus the hand-drawn shots it plays
(function () {
  'use strict';
  const G = window.G, W = G.W, H = G.H, C = G.COL, K = C.ink;
  const BAR = 26;

  // ---------- subtitle line with a typewriter that keeps pace with the voice ----------
  class Caption {
    constructor() { this.text = ''; this.t = 0; this.dur = 0; this.who = ''; this.shown = 0; }
    say(text, dur, who, blip) { this.text = text; this.dur = dur; this.t = 0; this.who = who || ''; this.shown = 0; this.blip = blip || 'text'; this.voiced = !!blip && blip === 'none'; }
    update(dt) {
      if (!this.text) return;
      this.t += dt;
      const rate = Math.max(22, this.text.length / Math.max(0.6, this.dur * 0.82));
      const n = Math.min(this.text.length, Math.floor(this.t * rate));
      if (n > this.shown) { if (this.blip !== 'none' && this.text[n - 1] !== ' ' && n % 2 === 0) G.audio.sfx(this.blip); this.shown = n; }
    }
    get done() { return !this.text || this.t >= this.dur; }
    draw(g, y, col) {
      if (!this.text) return;
      const lines = G.wrap(this.text, W - 56);
      let left = this.shown;
      const y0 = y - (lines.length - 1) * 5;
      lines.forEach((ln, i) => {
        const part = ln.slice(0, Math.max(0, left)); left -= ln.length + 1;
        if (part) G.text(g, part, Math.round(W / 2 - G.textW(ln) / 2), y0 + i * 11, col || C.paper, { shadow: '#000000' });
      });
      if (this.who) G.text(g, this.who, W / 2, y0 - 10, C.accentHi, { tiny: true, align: 'c' });
    }
  }
  G.Caption = Caption;
  const WHO = { nar: '', dev: 'THE DEVELOPER', sys: 'TERMINAL', nul: 'NULL', head: '<<<<<<< HEAD', theirs: '>>>>>>> THEIRS', leak: 'THE LEAK', loop: 'INFINITE LOOP', mono: 'THE MONOLITH' };
  G.whoName = (id) => { const m = G.VOICE && G.VOICE[id]; return m ? WHO[m.who] || '' : ''; };
  // play a voiced line through a caption; returns its duration
  G.speak = (cap, id, fallback) => {
    const has = G.voice.has(id), text = has ? G.voice.text(id) : fallback || '';
    let d = has ? G.voice.play(id) : 0;
    const voiced = d > 0;
    if (!d) d = 1.2 + text.length * 0.055;
    cap.say(text, d + 0.35, G.whoName(id), voiced ? 'none' : 'text');
    return d + 0.35;
  };

  // ---------- director ----------
  // script: { music, shots:[{ draw(g,t,S), dur, lines:[voiceId | {text,dur,who}], enter(S) }], end() }
  G.Cutscene = (script) => {
    const S = { i: -1, t: 0, line: -1, lineT: 0, cap: new Caption(), skip: 0, done: false, total: 0, vars: {} };
    const next = () => {
      S.i++; S.t = 0; S.line = -1; S.lineT = 0; S.cap.text = '';
      if (S.i >= script.shots.length) { S.done = true; G.voice.stop(); script.end(); return; }
      const sh = script.shots[S.i];
      if (sh.enter) sh.enter(S);
    };
    const nextLine = () => {
      const sh = script.shots[S.i];
      S.line++;
      if (!sh.lines || S.line >= sh.lines.length) { S.lineT = sh.tail === undefined ? 0.5 : sh.tail; S.cap.text = ''; S.lineDone = true; return; }
      const ln = sh.lines[S.line];
      if (typeof ln === 'string') S.lineT = G.speak(S.cap, ln);
      else { S.cap.say(ln.text, ln.dur || 1.4 + ln.text.length * 0.05, ln.who, ln.blip || 'text'); S.lineT = ln.dur || 1.4 + ln.text.length * 0.05; }
      if (sh.onLine) sh.onLine(S, S.line);
    };
    return {
      enter() { G.voice.warm(script.shots.flatMap((sh) => (sh.lines || []).filter((l) => typeof l === 'string'))); if (script.music !== undefined) { if (script.music) G.audio.music(script.music); else G.audio.stopMusic(); } next(); },
      update(dt) {
        if (S.done) return;
        const sh = script.shots[S.i], I = G.input;
        S.t += dt; S.total += dt; S.cap.update(dt);
        // hold to skip everything
        if (I.down.pause || I.down.start) { S.skip += dt; if (S.skip > 0.9 && !G.transitioning()) { S.done = true; G.voice.stop(); script.end(); return; } } else S.skip = 0;
        if (sh.lines) {
          if (S.line < 0) { if (S.t >= (sh.lead || 0.5)) { S.lineDone = false; nextLine(); } }
          else {
            S.lineT -= dt;
            const tap = (I.pressed.jump || I.pressed.attack) && S.t > 0.4;
            if (S.lineT <= 0 || tap) { if (S.lineDone) next(); else { if (tap) G.voice.stop(); nextLine(); } }
          }
        } else if (S.t >= (sh.dur || 2) || ((I.pressed.jump || I.pressed.attack) && sh.skippable !== false && S.t > 0.4)) next();
      },
      draw(g, ug) {
        if (S.i >= script.shots.length) { g.fillStyle = '#0d0a12'; g.fillRect(0, 0, W, H); return; }
        const sh = script.shots[S.i];
        sh.draw(g, S.t, S, ug);
        if (!sh.noBars) {
          ug.fillStyle = '#0d0a12'; ug.fillRect(0, 0, W, 14); ug.fillRect(0, H - BAR - 8, W, BAR + 8);
          S.cap.draw(ug, H - 22);
          if (S.skip > 0.1) { G.text(ug, 'skipping', W - 44, 4, C.dim, { tiny: true }); ug.fillStyle = C.accent; ug.fillRect(W - 44, 11, Math.min(34, S.skip / 0.9 * 34), 1); }
          else if (S.total < 4) G.text(ug, 'HOLD ENTER TO SKIP', W - 6, 4, '#4a4458', { tiny: true, align: 'r' });
        }
      },
    };
  };

  // =====================================================================
  // shots
  // =====================================================================
  const ROOM = {};
  function roomBase(dawn) {
    const key = dawn ? 'dawn' : 'night';
    if (ROOM[key]) return ROOM[key];
    const p = G.pix(W, H), g = p.g;
    const wall = dawn ? '#4a3a4a' : '#191827', wall2 = dawn ? '#5a4552' : '#1f1e30';
    p.rect(0, 0, W, H, wall);
    for (let x = 0; x < W; x += 24) p.rect(x, 0, 1, 150, wall2);
    // window
    const sky = dawn ? G.ditherGrad(92, 70, [[0, '#5a6aa8'], [0.45, '#e58a6a'], [0.8, '#ffc978'], [1, '#ffe9a8']]) : G.ditherGrad(92, 70, [[0, '#090d1c'], [0.7, '#14233f'], [1, '#22385a']]);
    p.rect(22, 22, 100, 78, '#0d0a12'); g.drawImage(sky, 26, 26);
    if (dawn) { G.disc(g, 50, 80, 10, '#fff3c4'); }
    else { G.disc(g, 96, 44, 8, '#f3e7c2'); G.disc(g, 93, 42, 2, '#e2d3a6'); const r = G.rng(4); for (let i = 0; i < 26; i++) p.px(28 + r() * 88, 28 + r() * 40, r() < 0.3 ? '#ffe9a8' : '#9fb4e0'); }
    // skyline
    const r2 = G.rng(9);
    for (let x = 26; x < 118; x += 9 + Math.floor(r2() * 8)) { const h = 10 + Math.floor(r2() * 26), wd = 7 + Math.floor(r2() * 7); p.rect(x, 96 - h, Math.min(wd, 118 - x), h, dawn ? '#3a3052' : '#0c1020'); if (!dawn) for (let y = 96 - h + 3; y < 94; y += 5) if (r2() < 0.4) p.px(x + 2 + Math.floor(r2() * (wd - 3)), y, '#ffd97a'); }
    p.rect(22, 22, 100, 4, '#2a2338').rect(22, 96, 100, 4, '#2a2338').rect(22, 22, 4, 78, '#2a2338').rect(118, 22, 4, 78, '#2a2338').rect(70, 22, 3, 78, '#2a2338').rect(22, 58, 100, 3, '#2a2338');
    p.rect(18, 100, 108, 4, '#3a3048');
    // wall clock + shelf + poster
    G.disc(g, 160, 40, 11, '#2a2338'); G.disc(g, 160, 40, 9, C.paper);
    if (dawn) { p.rect(160, 40, 1, 7, K).rect(160, 33, 1, 7, K); } else { p.line(160, 40, 156, 44, K).line(160, 40, 167, 43, K); }
    p.rect(300, 34, 66, 3, '#3a2a22'); p.rect(304, 20, 5, 14, '#d77757').rect(310, 22, 4, 12, '#7fd08a').rect(315, 19, 6, 15, '#f2c14e').rect(322, 23, 4, 11, '#7cc4ff').rect(350, 24, 10, 10, '#5a4a6a');
    p.rect(352, 20, 2, 4, '#7fd08a').rect(356, 18, 2, 6, '#7fd08a').rect(349, 21, 2, 3, '#7fd08a');
    // desk
    p.rect(0, 150, W, 66, '#2a1c18').rect(0, 150, W, 5, '#6a4a34').rect(0, 155, W, 2, '#4a3226');
    // monitor
    p.rect(214, 132, 12, 20, '#15131c').rect(196, 148, 48, 4, '#22202c');
    p.rect(156, 58, 128, 80, '#15131c').rect(158, 60, 124, 76, '#2c2a3a');
    p.rect(162, 64, 116, 68, '#06080a');
    // sticky notes on the bezel
    p.rect(150, 70, 9, 9, '#f2e27a').rect(281, 96, 9, 9, '#ff9db5').rect(150, 84, 9, 9, '#9be3a8');
    // keyboard
    p.rect(176, 158, 88, 12, '#22202c').rect(176, 158, 88, 2, '#3a3648'); for (let i = 0; i < 20; i++) for (let j = 0; j < 3; j++) p.rect(179 + i * 4.2, 161 + j * 3, 3, 2, '#4a4658');
    // mugs, duck
    const mug = (x, y) => { p.rect(x, y, 9, 10, C.paper).rect(x, y + 8, 9, 2, '#c9bfae').rect(x + 9, y + 2, 3, 1, C.paper).rect(x + 11, y + 3, 1, 4, C.paper).rect(x + 9, y + 7, 3, 1, C.paper).rect(x + 1, y + 1, 7, 1, '#4a2e20'); };
    mug(296, 142); mug(310, 144); mug(130, 143);
    p.ell(336, 147, 6, 5, '#f2c14e'); p.ell(340, 140, 4, 4, '#f2c14e'); p.rect(343, 140, 4, 2, '#e8743a'); p.px(341, 139, K); p.rect(330, 149, 12, 2, '#d9a53a');
    return (ROOM[key] = p.c);
  }
  // S.screen: 'fail' | 'prompt' | 'pass'; S.asleep: 0..1
  function drawRoom(g, t, o) {
    g.drawImage(roomBase(o.dawn), 0, 0);
    const sx = 162, sy = 64;
    // screen content
    if (o.screen === 'fail') {
      const lines = ['FAIL  test_checkout', 'FAIL  test_login', 'FAIL  test_cart', 'FAIL  test_legacy_core', 'FAIL  test_billing', 'FAIL  test_utils', 'FAIL  test_everything'];
      const off = Math.floor(t * 3);
      for (let i = 0; i < 6; i++) { const ln = lines[(i + off) % lines.length]; g.fillStyle = C.bad; g.fillRect(sx + 4, sy + 5 + i * 9, 17, 6); G.text(g, ln.slice(0, 4), sx + 5, sy + 5 + i * 9, '#1a0a0a', { tiny: true }); G.text(g, ln.slice(6), sx + 25, sy + 5 + i * 9, '#c9bfae', { tiny: true }); }
      G.text(g, '341 failed, 2 passed', sx + 4, sy + 60, C.bad, { tiny: true });
    } else if (o.screen === 'prompt') {
      G.text(g, 'TODO.txt', sx + 5, sy + 6, '#7dff9a', { tiny: true });
      const msg = 'fix it. please.', n = Math.min(msg.length, Math.floor((o.typed || 0)));
      g.fillStyle = '#1c1a26'; g.fillRect(sx + 4, sy + 18, 108, 14);
      G.text(g, '-', sx + 7, sy + 22, C.accent, { tiny: true });
      G.text(g, msg.slice(0, n), sx + 14, sy + 22, C.paper, { tiny: true });
      if (((t * 3) | 0) % 2) { g.fillStyle = C.accent; g.fillRect(sx + 14 + G.textW(msg.slice(0, n), { tiny: true }) + (n ? 2 : 0), sy + 21, 3, 6); }
      if (o.sent) { G.text(g, '(nobody reads it)', sx + 7, sy + 32, C.dim, { tiny: true }); }
    } else if (o.screen === 'pass') {
      g.fillStyle = C.ok; g.fillRect(sx + 4, sy + 6, 17, 6); G.text(g, 'PASS', sx + 5, sy + 6, '#0a1a0a', { tiny: true }); G.text(g, 'all suites', sx + 25, sy + 6, '#c9bfae', { tiny: true });
      G.text(g, '✓ 343 passed', sx + 5, sy + 20, C.ok, { tiny: true }); G.text(g, '0 failed', sx + 5, sy + 29, C.dim, { tiny: true });
      G.text(g, 'all green', sx + 5, sy + 44, C.okHi, { tiny: true });
      G.drawHero(g, sx + 96, sy + 62, { u: 1, face: -1, blink: (t % 3) < 0.15 });
    }
    const glow = o.screen === 'fail' ? '#ff5d5d' : o.screen === 'pass' ? '#7fd08a' : '#ffb38a';
    G.light(220, 98, 150, glow, 0.9, 0.3 + Math.sin(t * 7) * 0.02);
    if (o.dawn) G.light(72, 80, 190, '#ffc978', 0.9, 0.3); else G.light(96, 44, 60, '#cfe0ff', 0.5, 0.2);
    // the developer, seen from behind
    const sl = G.ease.io(G.clamp(o.asleep || 0, 0, 1)), hx = 232 - sl * 4, hy = 118 + sl * 34;
    const hood = '#3a3350', hood2 = '#2a2440';
    g.fillStyle = hood2; g.fillRect(196, 150 + Math.round(sl * 6), 76, 66);
    g.fillStyle = hood; g.fillRect(200, 146 + Math.round(sl * 8), 68, 70); g.fillRect(206, 140 + Math.round(sl * 10), 56, 10);
    G.disc(g, hx, hy, 17, hood); G.disc(g, hx, hy + 2, 13, '#4a3a2a');
    g.fillStyle = hood; g.fillRect(Math.round(hx) - 17, Math.round(hy) + 6, 35, 14);
    if (!o.asleep && o.typing && ((t * 9) | 0) % 2) { g.fillStyle = hood; g.fillRect(190, 158, 10, 6); g.fillRect(266, 157, 10, 6); }
    if (sl > 0.9) for (let i = 0; i < 3; i++) { const u = (t * 0.5 + i / 3) % 1; G.text(g, 'z', hx + 16 + u * 14, hy - 14 - u * 22, G.rgba('#f4ede0', 1 - u), { tiny: i < 2 }); }
    // steam
    for (let i = 0; i < 3; i++) { const u = (t * 0.35 + i / 3) % 1; g.fillStyle = G.rgba('#ffffff', 0.25 * (1 - u)); g.fillRect(Math.round(300 + Math.sin(u * 6 + i) * 2), Math.round(140 - u * 14), 1, 2); }
    G.ambient = o.dawn ? null : '#8a86b8';
  }

  // black terminal where your friend is born
  function drawTerminal(g, t, o) {
    g.fillStyle = '#0b0a10'; g.fillRect(0, 0, W, H);
    for (let y = 0; y < H; y += 3) { g.fillStyle = 'rgba(255,255,255,0.012)'; g.fillRect(0, y, W, 1); }
    G.text(g, '~/project  (main ✗)', 28, 30, '#4a4458');
    G.text(g, '$ cat TODO.txt', 28, 46, '#7dff9a');
    G.panel(g, 24, 62, W - 48, 22, '#15131c', '#3a3346');
    G.text(g, '-', 32, 69, C.accent); G.text(g, o.msg || 'fix it. please.', 44, 69, C.paper);
    if (o.reply) { G.text(g, '-', 30, 96, C.accent); G.text(g, o.reply.slice(0, Math.floor(o.replyN || 99)), 42, 96, C.paper); }
    G.ambient = '#b0a8c8';
  }

  const moth = (g, x, y, t, landed) => {
    const flap = landed ? ((t * 2) | 0) % 2 : ((t * 16) | 0) % 2;
    g.fillStyle = '#e9e2d0';
    if (flap) { g.fillRect(x - 4, y - 3, 3, 3); g.fillRect(x + 2, y - 3, 3, 3); } else { g.fillRect(x - 5, y - 1, 4, 2); g.fillRect(x + 2, y - 1, 4, 2); }
    g.fillStyle = '#8a7f6a'; g.fillRect(x - 1, y - 2, 3, 4); g.fillStyle = K; g.fillRect(x, y - 2, 1, 1);
    G.light(x, y, 26, '#fff3c4', 0.8, 0.3);
  };

  // ---------- intro ----------
  G.CUT = {};
  G.CUT.intro = (end) => G.Cutscene({
    music: 'night',
    shots: [
      { lead: 1.2, lines: ['nar_intro1', 'nar_intro2'], draw(g, t) { drawRoom(g, t, { screen: 'fail', typing: false }); G.text(g, '02:47', 148, 18, '#4a4458', { tiny: true }); } },
      {
        lines: ['nar_intro3'],
        draw(g, t) {
          g.fillStyle = '#06080a'; g.fillRect(0, 0, W, H);
          const r = G.rng(77);
          for (let y = 18; y < H - 30; y += 8) { let x = 14 + Math.floor(r() * 4) * 8; while (x < W - 40) { const wd = 8 + Math.floor(r() * 40); g.fillStyle = r() < 0.2 ? '#1f7a3a' : '#123a20'; if (r() < 0.8) g.fillRect(x, y + ((t * 14) | 0) % 8 * 0, wd, 3); x += wd + 5; } }
          // something opens its eye inside the code
          const o = G.clamp((t - 2.2) / 1.2, 0, 1), hgt = Math.round(o * 12);
          if (hgt > 0) { g.fillStyle = '#06080a'; g.fillRect(W / 2 - 34, H / 2 - 30, 68, 44); g.fillStyle = '#eafff0'; for (let y = -hgt; y <= hgt; y++) { const hw = Math.floor(26 * Math.sqrt(Math.max(0, 1 - (y / Math.max(1, hgt)) ** 2))); g.fillRect(W / 2 - hw, H / 2 - 8 + y, hw * 2, 1); } if (hgt > 5) { G.disc(g, W / 2 + Math.sin(t * 2) * 6, H / 2 - 8, 8, '#3cff7a'); G.disc(g, W / 2 + Math.sin(t * 2) * 6, H / 2 - 8, 4, K); } G.light(W / 2, H / 2 - 8, 110, '#3cff7a', 1, 0.35 * o); }
          if (t > 2.2 && t < 2.3) G.audio.sfx('roar');
          G.ambient = '#6a8a78';
        },
      },
      {
        lines: ['nar_intro4', 'dev_fixit'], tail: 1.6,
        onLine(S, i) { if (i === 1) S.vars.typeAt = S.t; },
        draw(g, t, S) {
          const ta = S.vars.typeAt, typed = ta !== undefined ? (t - ta) * 9 : 0;
          if (ta !== undefined && typed < 15 && Math.floor(typed) !== Math.floor(typed - 0.16)) G.audio.sfx('key');
          drawRoom(g, t, { screen: 'prompt', typed, typing: ta !== undefined && typed < 15, sent: typed > 17, asleep: ta !== undefined ? (t - ta - 2.3) / 1.2 : 0 });
        },
      },
      {
        lines: ['nar_intro5', { text: 'It has until sunrise.', dur: 2.6 }], tail: 1.7,
        enter(S) { S.vars.born = 0; },
        draw(g, t, S) {
          drawTerminal(g, t, {});
          // a cursor that decides to be something more
          const x = 60, y = 150, b = G.clamp((t - 1.6) / 2.2, 0, 1);
          if (b <= 0) { if (((t * 2.5) | 0) % 2) { g.fillStyle = C.accent; g.fillRect(x - 3, y - 12, 6, 12); } G.light(x, y - 6, 30, C.accent, 1, 0.3); }
          else {
            if (!S.vars.born) { S.vars.born = 1; G.audio.sfx('agent'); }
            const u = 3, grow = G.ease.back(Math.min(1, b * 2.2));
            const hop = t > 8.6 ? -Math.abs(Math.sin((t - 8.6) * 7)) * 10 : 0;
            G.drawHero(g, x + (t > 6.2 ? Math.min(60, (t - 6.2) * 26) : 0), y + hop, {
              u, sx: 0.5 + 0.5 * grow, sy: grow, face: t > 4.6 && t < 5.4 ? -1 : 1,
              legs: b > 0.55 ? [2, 2, 2, 2] : [0, 0, 0, 0], noEyes: b < 0.75, blink: b < 0.86 || (t % 2.6) < 0.12,
              armL: b > 0.4 ? 0 : 3, armR: b > 0.4 ? 0 : 3,
            });
            G.light(x + 20, y - 14, 80, '#ffb38a', 1, 0.3);
            if (b > 0.74 && b < 0.78) G.audio.sfx('uiOk');
          }
        },
      },
    ],
    end,
  });

  // ---------- world title cards ----------
  G.CUT.world = (w, end) => {
    const th = G.THEME[w];
    return G.Cutscene({
      music: null,
      shots: [{
        lead: 0.9, lines: ['nar_w' + w], tail: 0.6,
        enter() { G.audio.sfx('logo'); },
        draw(g, t, S, ug) {
          G.drawBG(w, g, t * 14, 0, G.time, 0);
          G.ambient = th.ambient;
          g.fillStyle = 'rgba(13,10,18,0.35)'; g.fillRect(0, 0, W, H);
          const k = G.ease.out(G.clamp(t / 0.7, 0, 1));
          G.text(ug, 'WORLD ' + w, W / 2, 62 - (1 - k) * 20, th.accent, { align: 'c', sp: 3, outline: K });
          G.text(ug, th.name, W / 2, 78, C.paper, { align: 'c', scale: 2, outline: K, shadow: K });
          const k2 = G.clamp((t - 0.5) / 0.5, 0, 1);
          if (k2 > 0) { ug.fillStyle = th.accent; ug.fillRect(W / 2 - 60 * k2, 103, 120 * k2, 1); G.text(ug, th.path + '  •  ' + th.time + ' AM', W / 2, 109, C.dim, { align: 'c' }); }
        },
      }],
      end,
    });
  };

  // ---------- new tool ----------
  const TOOLS = {
    bash: { name: 'Bash', voice: 'sys_bash', key: 'C', desc: 'Dash in any direction. Smashes through cracked blocks and bugs. Recharges when you land.' },
    agents: { name: 'Fireflies', voice: 'sys_agents', key: 'V', desc: 'Fill the firefly meter, then let them go: two tiny fireflies hunt bugs for you.' },
    sudo: { name: 'sudo', voice: 'sys_sudo', key: 'Z', desc: 'Elevated privileges. Jump again in mid-air.' },
    opus: { name: 'Big Swipe', voice: 'sys_opus', key: 'X', desc: 'A bigger swipe. Reaches further, hits twice as hard.' },
  };
  G.TOOLS = TOOLS;
  G.CUT.tool = (key, end) => {
    const tl = TOOLS[key];
    return G.Cutscene({
      music: null,
      shots: [{
        noBars: true, lead: 0.5, lines: [tl.voice], tail: 2.4,
        enter() { G.audio.music('toolget'); },
        draw(g, t, S, ug) {
          g.fillStyle = '#15121c'; g.fillRect(0, 0, W, H);
          for (let i = 0; i < 14; i++) { const a = (i / 14) * 6.283 + t * 0.3; g.fillStyle = i % 2 ? '#1c1826' : '#211c2d'; g.beginPath(); g.moveTo(W / 2, 84); g.lineTo(W / 2 + Math.cos(a) * 400, 84 + Math.sin(a) * 400); g.lineTo(W / 2 + Math.cos(a + 0.224) * 400, 84 + Math.sin(a + 0.224) * 400); g.fill(); }
          const k = G.ease.back(G.clamp(t / 0.5, 0, 1));
          G.drawHero(g, W / 2, 104 - Math.abs(Math.sin(t * 5)) * 6 * (t < 2 ? 1 : 0), { u: 4, sx: k, sy: k, eyes: 'shut', armL: -3, armR: -3 });
          G.light(W / 2, 80, 130, '#ffd9a0', 1, 0.3);
          G.text(ug, 'NEW TOOL', W / 2, 24, C.gold, { align: 'c', sp: 4, outline: K });
          G.text(ug, tl.name, W / 2, 120, C.paper, { align: 'c', scale: 2, outline: K, shadow: K });
          const lines = G.wrap(tl.desc, 250);
          lines.forEach((ln, i) => G.text(ug, ln, W / 2, 146 + i * 11, '#c9bfd8', { align: 'c' }));
          const kw = G.keycap(ug, W / 2 - 8, 146 + lines.length * 11 + 5, tl.key);
          void kw;
          if (t > 2 && ((t * 2) | 0) % 2) G.text(ug, 'press Z', W / 2, H - 14, C.dim, { align: 'c', tiny: true });
        },
      }],
      end,
    });
  };

  // ---------- ending ----------
  G.CUT.ending = (end) => {
    const stars = []; const r = G.rng(3); for (let i = 0; i < 40; i++) stars.push([r() * W, r() * H, r()]);
    return G.Cutscene({
      music: 'night',
      shots: [
        {
          lead: 1.4, lines: ['nar_end1', 'nar_end2'],
          draw(g, t) {
            // inside the broken monolith: a relay cabinet and one warm lamp
            g.fillStyle = '#07080b'; g.fillRect(0, 0, W, H);
            const rr = G.rng(12);
            for (let i = 0; i < 46; i++) { const x = rr() * W, y = rr() * 150, wd = 6 + rr() * 30; g.fillStyle = '#0f2217'; g.fillRect(x, y, wd, 2); }
            g.fillStyle = '#15171c'; g.fillRect(0, 168, W, 48); g.fillStyle = '#2a2e38'; g.fillRect(0, 168, W, 2);
            g.fillStyle = '#1c1f26'; g.fillRect(236, 96, 64, 72); g.fillStyle = '#2a2e38'; g.fillRect(236, 96, 64, 2);
            for (let i = 0; i < 4; i++) for (let j = 0; j < 4; j++) { g.fillStyle = '#0b0c10'; g.fillRect(242 + i * 14, 104 + j * 15, 10, 10); g.fillStyle = '#3a3f4c'; g.fillRect(244 + i * 14, 106 + j * 15, 6, 2); }
            g.fillStyle = '#3a3f4c'; g.fillRect(267, 60, 2, 36); G.disc(g, 268, 56, 7, '#fff3c4'); G.disc(g, 268, 56, 4, '#ffffff');
            G.light(268, 56, 150, '#ffd98a', 1, 0.45 + Math.sin(t * 9) * 0.02);
            const a = t * 2.3; moth(g, Math.round(268 + Math.cos(a) * (18 + Math.sin(t * 5) * 5)), Math.round(58 + Math.sin(a * 1.3) * 12), t);
            const cx = Math.min(150, -20 + t * 26);
            G.drawHero(g, cx, 168, { u: 2, face: 1, legs: cx < 150 ? (((t * 8) | 0) % 2 ? [2, 1, 2, 1] : [1, 2, 1, 2]) : [2, 2, 2, 2], eyeY: cx >= 150 ? -1 : 0, blink: (t % 3.1) < 0.12 });
            G.light(cx, 150, 70, '#ffb38a', 0.8, 0.12);
            G.ambient = '#5a5a78';
          },
        },
        {
          lines: [{ text: 'It did not squash it. Some bugs are not meant to be squashed.', dur: 4.8 }], tail: 2,
          draw(g, t) {
            g.fillStyle = '#0b0a10'; g.fillRect(0, 0, W, H);
            G.disc(g, W / 2, 96, 86, '#15121c'); G.disc(g, W / 2, 96, 64, '#1c1826');
            const land = G.clamp((t - 1.6) / 1.4, 0, 1), e = G.ease.io(land);
            const mx = G.lerp(W / 2 + 70 + Math.sin(t * 5) * 10, W / 2 + 8, e), my = G.lerp(40 + Math.cos(t * 4) * 12, 74, e);
            G.drawHero(g, W / 2, 144, { u: 6, face: 0, eyeX: 0, eyeY: land < 1 ? -1 : 0, eyes: land >= 1 && t > 4 ? 'shut' : undefined, blink: (t % 2.7) < 0.12, lift: land >= 1 ? 0 : 0 });
            moth(g, Math.round(mx), Math.round(my), t, land >= 1);
            G.light(W / 2, 100, 150, '#ffc9a0', 1, 0.2);
            if (land >= 1 && t < 3.1) G.audio.sfx('heal');
            G.ambient = '#8a86a8';
          },
        },
        { lead: 1, lines: ['nar_end4', 'dev_end'], tail: 1.2, enter() { G.audio.music('ending'); }, onLine(S, i) { if (i === 1) S.vars.wake = S.t; }, draw(g, t, S) { const w = S.vars.wake; drawRoom(g, t, { dawn: true, screen: 'pass', asleep: w === undefined ? 1 : 1 - (t - w) / 0.5 }); G.text(g, '06:00', 148, 18, '#8a7a8a', { tiny: true }); } },
        {
          lines: ['nar_end5'], tail: 2.2,
          draw(g, t) {
            drawTerminal(g, t, { reply: 'done. sleep well.  (a friend from Leaf Town)', replyN: t * 16 });
            G.text(g, '343 tests passing • 1 moth relocated • all green', 42, 110, C.ok);
            G.drawHero(g, 70, 168, { u: 3, face: 1, blink: (t % 2.8) < 0.12 });
            moth(g, 76, 136, t, true);
            G.light(80, 150, 90, '#ffb38a', 1, 0.25);
          },
        },
        {
          noBars: true, dur: 46, skippable: false,
          draw(g, t, S, ug) {
            // credits over the Source Tree at first light
            G.drawBG(1, g, t * 18, 0, G.time, 0);
            g.fillStyle = 'rgba(255,170,110,0.16)'; g.fillRect(0, 0, W, H);
            g.fillStyle = '#18413f'; g.fillRect(0, 196, W, 20);
            G.drawHero(g, 120, 196, { u: 2, face: 1, legs: ((t * 8) | 0) % 2 ? [2, 1, 2, 1] : [1, 2, 1, 2], lift: ((t * 8) | 0) % 2 ? -1 : 0, blink: (t % 3) < 0.12 });
            moth(g, 124, 166 + Math.round(Math.sin(t * 3)), t, true);
            G.ambient = '#f0d8c8';
            const roll = [
              ['LEAF-TOWN', 2], ['', 0], ['a small game about a small friend', 0], ['', 0], ['', 0],
              ['STARRING', 1], [G.hero().en, 0], ['', 0],
              ['WITH', 1], ['NULL  •  the null pointer', 0], ['MERGE CONFLICT  •  HEAD & theirs', 0], ['THE LEAK  •  never freed', 0], ['INFINITE LOOP  •  still running somewhere', 0], ['THE MONOLITH  •  legacy.c', 0], ['', 0],
              ['AND', 1], ['one moth (relocated, unharmed)', 0], ['', 0],
              ['CODE, PIXELS & MUSIC', 1], ['written line by line, note by note', 0], ['', 0],
              ['VOICES', 1], ['Fish Audio', 0], ['', 0],
              ['BASED ON', 1], ['CLAWD: EXIT CODE 0', 0], ['', 0],
              ['NO BUGS WERE HARMED', 1], ['(that is a lie. many bugs were harmed.)', 0], ['', 0], ['', 0],
              ['leaves found: ' + G.save.sparkCount() + ' / 39', 0], ['times segfaulted: ' + G.save.data.deaths, 0], ['', 0], ['', 0], ['', 0],
              ['Thank you for playing.', 2],
            ];
            let y = H + 10 - t * 15;
            for (const [txt, kind] of roll) {
              if (y > -20 && y < H + 10 && txt) G.text(ug, txt, 250, y, kind === 1 ? C.gold : C.paper, { align: 'c', scale: kind === 2 ? 1 : 1, outline: K, tiny: kind === 1, sp: kind === 1 ? 2 : 1 });
              y += kind === 2 ? 16 : kind === 1 ? 10 : 13;
            }
            if (y < 60) { S.t = 99; }
            void stars;
          },
        },
        {
          noBars: true, dur: 600,
          draw(g, t, S, ug) {
            G.drawBG(1, g, 400 + t * 6, 0, G.time, 0);
            g.fillStyle = 'rgba(255,170,110,0.16)'; g.fillRect(0, 0, W, H);
            G.ambient = '#f0d8c8';
            G.text(ug, 'all green', W / 2, 86, C.okHi, { align: 'c', scale: 2, outline: K, shadow: K });
            G.text(ug, 'see you back in Leaf Town', W / 2, 112, C.paper, { align: 'c', outline: K });
            if (t > 2 && ((t * 2) | 0) % 2) G.text(ug, 'press Z', W / 2, 150, C.paper, { align: 'c', tiny: true, outline: K });
          },
        },
      ],
      end,
    });
  };
  G.drawRoom = drawRoom; G.drawMoth = moth;
})();

